import { useState } from "react"
import InputMask from "react-input-mask"
import { useController } from "react-hook-form"
import { Input } from "@mobi/ds"
import mergeDeep from "@mobi/utils/object/mergeDeep"
import { getDigitsForMasking, getMaskForQuantity } from "./utils"

import "./Quantity.scss"

import Less from "@mobi/ds/static/icons/outlined/menos.svg"
import Plus from "@mobi/ds/static/icons/outlined/mais.svg"

const DEFAULT_MESSAGES = {
  required: "campo obrigatório",
}

const Quantity = ({
  resetField,
  name,
  min = 1,
  max = 99,
  maskSuffix = "",
  control,
  validators: { rules: propRules = {}, messages: propMessages = {} } = {},
  onChange = () => { },
  onBlur = () => { },
  required = true,
  disabled = false,
  ...props
}) => {
  const formRules = mergeDeep(propRules, { required })
  const errorMessages = mergeDeep(DEFAULT_MESSAGES, propMessages)

  const {
    field,
    fieldState: { invalid, error, isTouched, isDirty },
  } = useController({ name, control, rules: formRules })


  const isInvalid = isTouched && invalid && isDirty
  const maxQuantity = max
  const minQuantity = min

  const maxLength = maxQuantity.toString().length
  const digits = getDigitsForMasking(maxLength)

  const [maskInput, setMaskInput] = useState(
    getMaskForQuantity(digits, maskSuffix)
  )

  const handleDecrement = () => {
    let value = field?.value?.toString()?.replaceAll(maskSuffix, "") || 0
    value = Number(value)
    if (value > min) {
      const newValue = value - 1
      field.onChange(newValue.toString())
      handleBlur(null, newValue.toString())
    }
  }

  const handleIncrement = () => {
    let value = field?.value?.toString()?.replaceAll(maskSuffix, "") || 0
    value = Number(value)
    if (value < maxQuantity) {
      const newValue = value + 1
      field.onChange(newValue.toString())
      handleBlur(null, newValue.toString())
    }
  }

  const handleChange = (event) => {
    let value = event.target.value.replaceAll(maskSuffix, "").replace(/_/g, "")
    value = Number(value) || ""

    if(resetField && value === ""){
      return resetField(name)
    }
    if (value > maxQuantity) {
      return field.onChange(maxQuantity.toString())
    }
    if (value < minQuantity) {
      return field.onChange(minQuantity.toString())
    }

    field.onChange(value.toString())
    onChange(event)
  }

  const handleBlur = (event, value) => {
    if(field?.value === undefined) return
    
    let currentValue =
      value?.toString() ||
      field?.value?.toString()?.replaceAll(maskSuffix, "") ||
      ""

    const inputMask = getMaskForQuantity(
      getDigitsForMasking(currentValue?.length),
      maskSuffix
    )

    currentValue !== "" && setMaskInput(inputMask)
    currentValue === "" && field.onChange("")

    field.onBlur && field.onBlur(event)
    onBlur(event)
  }

  const handleFocus = (event) => {
    const inputMask = getMaskForQuantity(digits, maskSuffix)
    setMaskInput(inputMask)
    props.onFocus && props.onFocus(event)
  }

  return (
    <div className="ds-quantity">
      <InputMask
        {...props}
        {...field}
        maskChar=""
        mask={maskInput}
        alwaysShowMask={true}
        onChange={handleChange}
        onBlur={handleBlur}
        onFocus={handleFocus}
        isValid={!isInvalid}
        errorMessage={errorMessages[error?.type]}
        aria-required={required}
        disabled={disabled}
      >
        <Input.Default
          type="text"
          inputMode="numeric"
          name={field.name}
        />
      </InputMask>
      <div className="ds-quantity__sr-only-feedback" aria-live="polite">{`${field?.value || 0} ${maskSuffix}`}</div>
      <div className="ds-quantity__btn-wrapper">
        <button
          type="button"
          onClick={handleDecrement}
          className={`ds-quantity__btn ${disabled ? 'ds-quantity__btn--disabled' : ''}`}
          aria-label="subtrair"
          disabled={disabled}
        >
          <Less />
        </button>
        <button
          type="button"
          onClick={handleIncrement}
          className={`ds-quantity__btn ${disabled ? 'ds-quantity__btn--disabled' : ''}`}
          aria-label="adicionar"
          disabled={disabled}
        >
          <Plus />
        </button>
      </div>
    </div>
  )
}

export default Quantity